import type { ReactNode } from "react";

export interface AccessCardFieldProps {
  label: string;
  children: ReactNode;
}

/**
 * One labelled field inside a mobile card.
 *
 * Label above value, never `label: value` on one line — a phone column is too narrow for the second form,
 * which wraps into something that reads as two unrelated fragments.
 *
 * Not shared with `users/components/UsersCards.tsx`: that one has its own type scale and no mono label, and
 * unifying them would change how `/app/users` renders.
 */
export function AccessCardField({ label, children }: AccessCardFieldProps) {
  return (
    <div className="min-w-0">
      <div className="font-mono text-[9.5px] uppercase tracking-[0.06em] text-muted-foreground/80">
        {label}
      </div>
      <div className="mt-0.5">{children}</div>
    </div>
  );
}
